export default "__VITE_ASSET__C1UTzvyO__"